// extracted by mini-css-extract-plugin
export default {"user-creator":"user-creator_user-creator__d6Z2A","user-creator__body":"user-creator_user-creator__body__Klphk"};